<template>
  <header class="header">
    <div class="header-left">
      <button class="hamburger-btn" @click.stop="toggleSidebar">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </button>
      <div class="breadcrumb">
        <span>AI 控制台</span>
        <span class="breadcrumb-separator">/</span>
        <span class="current">{{ navStore.breadcrumbTitle }}</span>
      </div>
      <div class="mobile-title">{{ navStore.breadcrumbTitle }}</div>
    </div>

    <div
      class="header-actions"
      style="display: flex; align-items: center; gap: 16px"
    >
      <div v-if="userStore.userInfo" class="balance-badge">
        算力: {{ userStore.userInfo.balance }}
      </div>

      <UserDropdown
        :open="userStore.headerMenuOpen"
        :user-name="userStore.userInfo?.username || userStore.userName"
        :avatar="avatar"
        @toggle="userStore.toggleHeaderMenu"
        @go-account="goAccountManage"
        @logout="handleLogout"
      />
    </div>
  </header>
</template>

<script setup>
import { inject, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import UserDropdown from "./UserDropdown.vue";
import { useNavStore } from "@/stores/useNavStore";
import { useAuthStore } from "@/stores/useAuthStore";

const navStore = useNavStore();
const userStore = useAuthStore();
const router = useRouter();
const avatar = "/默认头像.svg";

const toggleSidebar = inject("toggleSidebar");

const goAccountManage = () => {
  userStore.closeHeaderMenu();
  router.push("/account");
};

const handleLogout = async () => {
  userStore.closeHeaderMenu();
  try {
    await userStore.logout();
  } finally {
    router.push("/login");
  }
};

const onWindowClick = () => {
  userStore.closeHeaderMenu();
};

onMounted(() => {
  window.addEventListener("click", onWindowClick);
});

onUnmounted(() => {
  window.removeEventListener("click", onWindowClick);
});
</script>

<style scoped>
.balance-badge {
  padding: 4px 12px;
  background-color: #eaf2ff;
  color: #165dff;
  border-radius: 999px;
  font-size: 14px;
  font-weight: bold;
  border: 1px solid #bdd4ff;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.hamburger-btn {
  display: none;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: var(--text-title);
}
.mobile-title {
  display: none;
  font-size: 16px;
  font-weight: 600;
}
@media (max-width: 768px) {
  .hamburger-btn {
    display: flex;
    align-items: center;
  }
  .breadcrumb {
    display: none;
  }
  .mobile-title {
    display: block;
  }
  .balance-badge {
    display: none;
  }
}
</style>
